<div class="top-bar">
  <img src="./assets/images/group-logo.svg" />
  <sync-icon matTooltip="Help" name="help" />
</div>

<div class="content" [class.error]="errcode">
  <ng-container *ngIf="!errcode">
    <img class="logo" src="./assets/images/logo.svg" />
    <h1>Set a password</h1>
    <p>To complete your account set up, you will need to set a password for <b>{{email}}</b>.</p>

    <form *ngIf="isInviteChecked" [formGroup]="form" (ngSubmit)="resetPasswordSubmit()">
      <app-error
        *ngIf="passErrcode"
        [errcode]="passErrcode">
      </app-error>
      <div class="fields">
        <div class="new-password">
          <sync-text-field
            label="New password"
            inputType="password"
            formControlName="password"
            [errorMessage]="getErrorMessage('password')">
          </sync-text-field>
          <app-complex-password
            [password]="form.controls.password.value">
          </app-complex-password>
        </div>
        <sync-text-field
          label="Confirm password"
          inputType="password"
          formControlName="confirmPassword"
          [errorMessage]="getErrorMessage('confirmPassword')">
        </sync-text-field>
      </div>

      <sync-button
        [disabled]="!canSubmit"
        nativeType="submit"
        class="set-password"
        type="filled"
        label="Set password"
        [isLoading]="spinner"
        buttonWidth="236px">
      </sync-button>
    </form>

    <div *ngIf="!isInviteChecked" class="verifying-invite">
      <sync-spinner />
      <p>Verifying your invite</p>
    </div>
  </ng-container>

  <ng-container *ngIf="errcode">
    <img src="./assets/images/lock.svg" />
    <span class="error-title">
      {{
        errcode.code === 8137 ?
          'The invitation has expired' :
          errcode.msg
      }}
    </span>
    <span class="error-code">Error #{{errcode.code}}</span>
    <p>Please contact your admin to send a new invitation.</p>
    <sync-button
      label="Back to Sync"
      type="outlined"
      routerLink="/">
    </sync-button>
  </ng-container>

  <div class="footer">
    <span class="copyright">Copyright © {{ year }} Sync.com, Inc.</span>
    <span class="links"><a href="https://www.sync.com/terms/" target="_blank">Terms of service</a> · <a href="https://www.sync.com/privacy/" target="_blank">Privacy policy</a> · <a href="https://www.sync.com/privacy-policy-gdpr/" target="_blank">GDPR</a></span>
  </div>
</div>
